import { Box, keyframes, Typography } from "@mui/material";

const textFade = keyframes`
  0% {
    letter-spacing: -10px;
    filter: blur(3px);
    transform: translate3d(-50%, -50%, 0) scale(1);
  }
  50% {
    filter: blur(6px);
  }
  80% {
    letter-spacing: 0.5px;
    filter: blur(2px);
    transform: translate3d(-50%, -50%, 0) scale(0.95);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) scale(1);
    filter: blur(0px);
  }
`;

const pandaFade = keyframes`
  0% {
    transform: scale(0.8);
    filter: blur(6px);
    opacity: 0;
  }
  50% {
    opacity: 0.5;
    filter: blur(2px);
  }
  100% {
    transform: scale(1);
    filter: blur(0);
    opacity: 1;
  }
`;

const filterFade = keyframes`
  0% {
    filter: contrast(20);
  }
  25% {
    filter: contrast(15);
  }
  50% {
    filter: contrast(10);
  }
  75% {
    filter: contrast(5);
  }
  100% {
    filter: contrast(1);
  }
`;

export const Splash: React.FC = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        overflow: "hidden",
        background: "linear-gradient(180deg, #000000 0%, #230D4D 100%)",
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        sx={{
          width: "100%",
          height: "100%",
          animation: `${filterFade} 3s ease-in-out forwards`,
          "@media screen and (max-width: 900px)": {
            height: 600,
          },
          "@media screen and (max-width: 500px)": {
            height: 400,
          },
        }}
      >
        <Box
          sx={{
            width: "1440px",
            maxWidth: "100%",
            paddingLeft: "80px",
            margin: "0 auto",
            "& img": { objectFit: "cover", animation: `${pandaFade} 5s ease-in-out forwards` },
            display: "flex",
            alignItems: "center",
            "@media screen and (max-width: 1440px)": {
              width: "100%",
              paddingLeft: "5.5%",
              "& img": { width: "71.1%", height: "auto" },
            },
          }}
        >
          <img src={require("src/assets/images/panda.png")} alt="" width={1024} height={1024} />
        </Box>
        <Typography
          fontSize="183px"
          fontFamily="RacingSansOne"
          sx={{
            color: "white",
            lineHeight: 1,
            animation: `${textFade} 5s ease-in-out forwards`,
            display: "block",
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate3d(-50%, -50%, 0)",
            letterSpacing: "0.00938em",
            whiteSpace: "nowrap",
            "@media screen and (max-width: 1000px)": {
              fontSize: 120,
            },
            "@media screen and (max-width: 700px)": { fontSize: 85 },
            "@media screen and (max-width: 500px)": { fontSize: 65 },
          }}
        >
          SmartLabs
        </Typography>
      </Box>
    </Box>
  );
};

export default Splash;
